<template>
    <center>
        <div class="card card-body agatrs-card-style">
            <Header pageTitle="Manage Organizations" class="card-container"></Header>
            <div class="col-md-12" style="margin-left: 7px;">
                <div class="row">
                    <export-group :name="'Organizations'" :excelUrl="`api/organizations/excel`"
                        :getData="getExportData"></export-group>

                    <div class="col-md-5 col-sm-6 col-xs-6 align-right">
                        <base-button @click="openModal()" class="btn btn-secondary more-margin-top"><i
                                class="tim-icons icon-simple-add"></i> Create New Organization</base-button>
                    </div>
                    <div class="col-md-3">
                        <label for="searchBox">Search:</label>
                        <el-input id="searchBox" type="search" class="mb-3 search-input" clearable
                            prefix-icon="el-icon-search" @input="handleSearch('page1')" placeholder="Search"
                            v-model="searchText"
                            v-b-popover.hover.bottom="'Search results appear immediately upon typing.'"></el-input>
                    </div>
                </div>
            </div>

            <div style="margin-left: 22px !important ; margin-top: 20px !important;" class="row">
                <div class="col-md-3">
                    <label for="filterByCountry">Filter by Country:</label>
                    <v-select id="filterByCountry" v-model="countrySelection" name="CountiresDropdown" sortable
                        :reduce="item => item.countryId" label="name" :options="allCountries" placeholder="Select"
                        v-b-popover.hover.left="'If a country filter is not selected, search results will pull for all countries.'"></v-select>
                </div>
            </div>

            <div style="margin-left: 20px !important ; margin-right: 20px !important;" class="row">
                <el-table :data="paginatedOrganizations.results" role="table" aria-label="Admin Organizations Table">
                    <el-table-column :min-width="200" align="left" label="Actions">
                        <div slot-scope="props">
                            <router-link :to="'/admin/organizations/' + props.row.id" class="btn-link btn-primary">
                            </router-link>
                            <organization-edit :id="props.row.id">
              <template  v-slot:modal-link>
                <span class="btn-link btn-primary">
                                               <i class="tim-icons icon-pencil"></i> <span class="hide-if-small-screensize">Edit</span>
              </span>
              </template>
            </organization-edit>
                            <a href="##" @click="deleteOrganization(props.row.id)" class="btn-link btn-danger">
                                <i class="tim-icons icon-trash-simple"></i> <span
                                    class="hide-if-small-screensize">Delete</span>
                            </a>
                        </div>
                    </el-table-column>

                    <el-table-column v-for="column in tableColumns" sortable :key="column.label"
                        :min-width="column.minWidth" :prop="column.prop" :label="column.label"></el-table-column>
                </el-table>
            </div>

            <div class="row justify-content-end">
                <label for="ResultsPerPageDropdown" class="results-per-page">Results Per Page:</label>
                <el-select id="ResultsPerPageDropdown" v-model="resultsPerPage" @change="handleSearch('page1')"
                    name="PageOptions" class="select-primary" v-b-popover.hover.bottom="'# of Organizations per page.'">
                    <el-option v-for="(item, i) in pageCountOptions" :value="item" class="select-primary"
                        :key="i"></el-option>
                </el-select>

                <base-pagination v-model="selectedPageNumber" @input="handleSearch()"
                    :per-page="paginatedOrganizations.pageSize"
                    :pageCount="paginatedOrganizations.pageCount"></base-pagination>
            </div>

            <!-- Add Organization Modal -->
            <b-modal ref="showOrganizationsModal" hide-footer hide-header no-close-on-backdrop size="lg"
                body-class="custom_alert_body">
                <div class="alert_header align-center container">
                    Add Organization
                </div>
                <div class="container">
                    <label>Select a Country:</label>
                    <v-select v-model="organization.countryId" name="CountiresDropdown" :reduce="item => item.countryId"
                        label="name" :options="allCountries" placeholder="Select"
                        v-b-popover.hover.right="'Countries can be filtered by typing into this dropdown menu.'"></v-select>

                    <label>Organization Name:</label>
                    <base-input v-model="organization.name" placeholder="Please enter an organization name."></base-input>
                    <label>Organization Abbreviation:</label>
                    <base-input v-model="organization.abbreviation"
                        placeholder="Please enter an organization abbreviation."></base-input>
                
                    <div class="row justify-content-center more-top-padding">
                        <div >
                            <base-button @click="clickCloseModal()" class="btn-primary"
                                v-b-popover.hover.bottom="'Navigate back to organizations dashboard.'">
                                <i class="tim-icons icon-double-left"></i> Return to Table
                            </base-button>
                        </div>
                        <div >
                            <base-button @click="addOrg()" type="primary" v-b-popover.hover.bottom="'Save changes.'">
                                <i class="tim-icons icon-bank"></i> Save Changes
                            </base-button>
                        </div>
                    </div>
                </div>
            </b-modal>

        </div>
    </center>
</template>

<script>
import {
    mapGetters,
    mapActions
} from 'vuex';
import {
    Table,
    TableColumn,
    Select,
    Option
} from 'element-ui'
import { BaseButton, Modal, BasePagination, ExportGroup } from "@/components";
import Treeselect from "@riophae/vue-treeselect";
import Header from "@/components/App/Header.vue";
import swal from "sweetalert2";
import Util from "@/util/util";
import axios from "@/axios";
import OrganizationEdit from "@/components/App/office/OrganizationEdit.vue";

export default {
    name: "admin-organizations-dashboard",
    components: {
        [Table.name]: Table,
        [TableColumn.name]: TableColumn,
        BasePagination,
        Modal,
        [Select.name]: Select,
        [Option.name]: Option,
        Treeselect,
        Header,
        ExportGroup,
        OrganizationEdit
    },
    async mounted() { // The methods below need to be synchronous so that there are countries before selecting United States (default country).
        this.$loaderApp.addRequest();
        await this.getAllCountries()
        await this.selectUnitedStates()
        this.pageCountOptions = Util.getInitialPaginationInfo().perPageOptions;
        this.$loaderApp.completeRequest();
    },
    watch: {
        countrySelection() {
            this.handleSearch('page1')
        }
    },
    data() {
        return {
            firstWatch: true,
            map: {
                "Name": "name",
                "Abbreviation": "abbreviation",
                "CreateDate": "createDateLabel",
                "UpdateDate": "updateDateLabel",
            },
            tableColumns: [
                {
                    prop: 'name',
                    label: 'Organization Name',
                    minWidth: 210,
                    scope: "col"
                },
                {
                    prop: 'abbreviation',
                    label: 'Abbreviation',
                    minWidth: 200,
                    scope: "col"
                },
                {
                    prop: 'createDateLabel',
                    label: 'Created Date',
                    minWidth: 200,
                    scope: "col"
                },
                {
                    prop: 'updateDateLabel',
                    label: 'Modified Date',
                    minWidth: 200,
                    scope: "col"
                }
            ],
            form: {
                country: null,
                name: null,
                abbrev: null
            },
            selectedPageNumber: 1,
            resultsPerPage: 5,
            searchText: "",
            countrySelection: null,
            addCountrySelection: '',
            pageCountOptions: [],
        }
    },
    computed: {
        ...mapGetters({
            allOrganizations: 'organization/allOrganizations',
            paginatedOrganizations: 'organization/paginatedOrganizations',
            organization: 'organization/organization',
            allCountries: 'countries/allCountries'
        }),
        selectedCountry() {
            return this.countrySelection = this.allCountries.countryId;
        },
        selectedresultsPerPage() {
            return this.resultsPerPage
        },
        search() {
            return this.searchText;
        },
    },
    methods: {
        ...mapActions({
            deleteOrganizations: 'organization/deleteOrganizations',
            getOrganization: 'organization/getOrganization',
            updateOrganization: 'organization/updateOrganization',
            saveOrganization: 'organization/saveOrganization',
            getAllCountries: 'countries/getAllCountries',
            getPaginatedOrganizations: 'organization/getPaginatedOrganizations',
            getAllOrganizations: 'organization/getAllOrganizations'
        }),
        countrySelectedSearch(pageNum) {
            let pageInfo = {
                countryId: this.countrySelection,
                pageNumber: this.selectedPageNumber,
                resultsPerPage: this.resultsPerPage,
                searchText: this.searchText
            }
            this.getPaginatedOrganizations(pageInfo)
        },
        handleSearch(page1 = false) {
            clearTimeout(this.searchTimeOut);

            var self = this;
            self.searchTimeOut = setTimeout(function () {
                if (page1) {
                    self.selectedPageNumber = 1;
                }

                self.countrySelectedSearch(1);
            }, 1000);
        },
        selectUnitedStates() {
            this.countrySelection = this.allCountries.filter(item => item.twoCharacterCode == "US")[0].countryId; // Gets USA's Country ID
            this.handleSearch('page1')
        },
        async getExportData() {
            await this.getAllOrganizations({
                    searchText: this.searchText,
                    countryId: this.countrySelection
                });

            return Util.mapTheData(this.allOrganizations, this.map)
        },

        openModal() {
            this.getOrganization(0)
            this.$refs.showOrganizationsModal.show();
        },
        clickCloseModal() {
            this.$refs.showOrganizationsModal.hide();
        },
        addOrg() {
            // default is true;
            //this.organization.isActive=true;
            this.saveOrganization(true).then((response) => {
                this.handleSearch()
                this.clickCloseModal()
            });
        },
        async deleteOrganization(id) {
            var result = await new swal({
                title: "Delete Confirmation",
                text: `Do you want to delete organization #${id}?`,
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#10b45a",
                cancelButtonColor: "red",
                confirmButtonText: `Delete organization #${id}`,
                reverseButtons: true
            });
            var ctx = this;
            try {
                if (result.value) {
                    await this.getOrganization(id)
                    await this.deleteOrganizations(id);
                    await new swal({
                        title: "Confirmation of Delete",
                        text: "Organization has been deleted successfully.",
                        icon: "success",
                        confirmButtonColor: "#10b45a",
                        reverseButtons: true
                    })
                    ctx.handleSearch();
                }
            } catch(err) {
                this.$toast.error(err.response.data); 
            }
        },
    }
}
</script>

<style scoped>.results-per-page {
    padding-top: 10px;
    padding-right: 9px;
}</style>
